<template>
  <div>
    <Loader
      v-if="isLoading"
      class="pb-3"
    />
    <MultiSelectComponent
      v-else
      id="groupMagicSelect"
      v-model="select"
      class="mb-2 my-1 w-100"
      :max-selected-options="1"
      :label="trans('subscription.classification_config.selectors.group.select_group')"
      :type="'group'"
      track-by="id"
      :include="{ 'program_id': programId }"
      @input="changeInput"
    />
  </div>
</template>

<script>
import MultiSelectComponent from '@/employees/components/FormComponents/MultiSelectComponent'
import { mapState } from 'vuex'
import { GROUP_CATEGORY } from '@/constants'
export default {
  name: 'SelectorDatabaseGroup',
  components: {
    MultiSelectComponent,
  },
  inject: ['programId'],
  props: {
    selector: {
      required: true,
      type: Object,
    },
  },
  data () {
    return {
      select: [],
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      missingId (state) {
        if (!state.groups.groups.hasOwnProperty(this.selector.group) && this.selector.group?.id) {
          return this.selector.group?.id
        }
        return null
      },
      groups (state) {
        if (!state.groups.groups.hasOwnProperty(this.selector.group?.id)) {
          return []
        }
        const result = state.groups.groups[this.selector.group?.id]
        return [{
          id: this.selector.group?.id,
          name: result.name,
        }]
      },
    }),
  },
  mounted () {
    if (this.selector.group) {
      if (this.selector.group?.id) {
        //* This mechanism is build, because it is not clear when you can get all the relevant student characteristics
        //* can not currently be retrieved without rewriting a lot of back-end code
        if (this.missingId) {
          this.isLoading = true
          this.$store.dispatch('getGroups', {
            queryParams: {
              filter: {
                id: this.missingId,
              },
            },
          }).then(() => {
            this.select = this.groups
            this.isLoading = false
          })
        }
        this.select = this.groups
      }
    }
  },
  methods: {
    changeInput (newValue) {
      if (newValue.length > 0) {
        this.$emit('input', {
          type: GROUP_CATEGORY.database,
          id: newValue[0].id,
        })
      } else {
        this.$emit('input', null)
      }
    },
  },
}
</script>
